export default __webpack_public_path__ + "static/media/course4.43dfa45d.webp";